import { useQuery } from 'react-query'
import { getActionProviders } from '../../services'

export const useGetWorkflowActionProviders = () => useQuery(['workflow-actions-provider'], getActionProviders)

export default useGetWorkflowActionProviders
